import { render } from "./serviceOrganization.vue?vue&type=template&id=0fc01e3e&scoped=true"
import script from "./serviceOrganization.vue?vue&type=script&lang=js"
export * from "./serviceOrganization.vue?vue&type=script&lang=js"

import "./serviceOrganization.vue?vue&type=style&index=0&id=0fc01e3e&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc01e3e"]])

export default __exports__